import React, { useRef, useState, useEffect } from "react";
import Countdown from "../../Components/CountDown";
import axios from "axios";
interface Props {
  parentDetail: any;
  isEmailValid: boolean;
  createAccount: any;
  enquiryID: number;
  enquiryType: string;
  onClose: () => void;
  sendGa4RegisterParent: () => void;
  sendNewEventGa4: (payload) => void;
  listingType: string;
}

const VerifyOTP = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [guid, setGuid] = useState();
  const [startTime, setStartTime] = useState(false);
  const [typeSendOTP, setTypeSendOTP] = useState(
    props.parentDetail.isValidAustralianAreaCode && "email" ? "email" : "SMS"
  );
  const inputRefs = useRef([]);

  //Call API Send OTP
  useEffect(() => {
    props.sendNewEventGa4({
      eventName: "enquiry_workflow",
      Action: "start",
      FormStep: "register",
      ListingType: props.listingType,
    });
    handleCallSendOTP();
  }, []);

  const assignParentToEnquiry = (parentId, enquiryId) => {
    let headers = {
      "Content-Type": "application/json",
    };
    document.getElementById("signupOTPError").style.display = "none";
    document.getElementById("errors").innerHTML = "";

    axios
      .post(
        "/enquiry/assignparenttoenquiry",
        JSON.stringify({
          parentId,
          enquiryId,
          enquiryType: props.enquiryType,
        }),
        { headers: headers }
      )
      .then(() => {
        localStorage.setItem("clickEnquiriesButton", "true");

        props.onClose();
        const currentUrl = window.location.pathname;
        if (currentUrl !== "/") {
          window.location.href = currentUrl;
        } else {
          window.location.href = "/";
        }
      })
      .catch((error) => {
        document.getElementById("errors").style.display = "block";
        document.getElementById("errors").innerHTML = error.response?.data[0];
      })
      .finally(() => setLoading(false));
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").slice(0, 6);
    const newOtp = pastedData.split("");
    setOtp(newOtp);

    const nextEmptyIndex =
      pastedData.length < otp.length ? pastedData.length : otp.length - 1;
    inputRefs.current[nextEmptyIndex]?.focus();

    newOtp.forEach((char, index) => {
      if (inputRefs.current[index]) {
        inputRefs.current[index].value = char;
      }
    });

    if (newOtp.length === 6) {
      verifyOtp(newOtp.join(""));
    }
  };

  const verifyOtp = (otpCode) => {
    document.getElementById("errors").style.display = "none";
    if (props.isEmailValid) {
      setLoading(true);
      fetch(`/parentaccount/verifyotp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: guid,
          otp: otpCode,
        }),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.Data) {
            assignParentToEnquiry(res.Data.UserId, props.enquiryID);
            document.cookie = "c4kc=" + res.Data.BearerToken + "; path=/";
          } else {
            document.getElementById("errors").style.display = "block";
            document.getElementById("errors").innerHTML =
              "Oops the code is incorrect try again";
          }
        })
        .catch((error) => {
          document.getElementById("errors").style.display = "block";
          document.getElementById("errors").innerHTML =
            "Oops the code is incorrect try again";
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(true);
      fetch("/parentaccount/enquiryflow/registerparent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: props.parentDetail.parentFirstName,
          lastName: props.parentDetail.parentLastName,
          email: props.parentDetail.email,
          verificationId: guid,
          otpCode,
          postCode: Number(props.parentDetail.suburb.postcode),
          phoneNumber: props.parentDetail.contactNumber,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data && data.Data) {
            props.sendGa4RegisterParent();
            assignParentToEnquiry(data.Data.id, props.enquiryID);
          } else {
            document.getElementById("errors").style.display = "block";
            document.getElementById("errors").innerHTML =
              "Oops the code is incorrect try again";
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          document.getElementById("errors").style.display = "block";
          document.getElementById("errors").innerHTML = error.response?.data[0];
        });
    }
  };

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
    if (newOtp.every((char) => char !== "")) {
      verifyOtp(newOtp.join(""));
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleCallSendOTP = () => {
    fetch(`/parentaccount/sendotpv3`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: props.parentDetail.email,
        sendOverEmail: props.parentDetail.isValidAustralianAreaCode,
        ...(!props.parentDetail.isValidAustralianAreaCode && {
          phoneNumber: props.parentDetail.contactNumber,
        }),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setGuid(data.Id);
          setStartTime(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleTryAnotherMethod = () => {
    setTypeSendOTP((prev) => {
      console.log(prev);
      fetch(`/parentaccount/sendotpv3`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: props.parentDetail.email,
          sendOverEmail: prev === "email" ? false : true,
          ...(prev === "email" && {
            phoneNumber: props.parentDetail.contactNumber,
          }),
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            setGuid(data.Id);
            setStartTime(true);
            setOtp(new Array(6).fill(""));
          }
        })
        .catch((error) => {
          console.error(error);
        });

      return prev === "email" ? "SMS" : "email";
    });
  };

  return (
    <div className="mb-4 text-[#484554] relative">
      {loading && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-white z-10 w-full"
          style={{ backgroundColor: `rgba(255, 255, 255, 0.5` }}
        >
          <span className="flex items-center gap-2">
            <img
              className="mix-blend-multiply"
              src="/img/navy-spinner.svg"
              alt="Spinner white dots circle"
            />
          </span>
        </div>
      )}
      <h1 className="mb-6 font-semibold text-[24px] text-[#484554]">
        We just sent you an {typeSendOTP == "email" ? "email" : "SMS"}
      </h1>
      <p className="text-[16px] mb-6">
        {typeSendOTP == "email" ? (
          <>
            Enter the security code we sent{" "}
            <span className="font-semibold">{props.parentDetail.email}</span>.
            Please check your inbox to view code, and if you don’t see it, check
            your spam or junk folder.
          </>
        ) : (
          `Enter the security code we sent to ${props.parentDetail.contactNumber}`
        )}
      </p>
      <div id="resetOTPCount" className="mb-4 flex font-medium justify-start">
        <Countdown startTime={startTime} key={guid} />
      </div>
      <div className="w-fit flex space-x-2 justify-center rounded-[8px] border border-[#D9D8DF]">
        {otp.map((value, index) => {
          return (
            <div
              key={index}
              className="relative w-12 h-16 flex items-center justify-center gap-[24px]"
            >
              <input
                key={index}
                type="text"
                maxLength={1}
                value={value}
                onPaste={handlePaste}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*$/.test(val)) {
                    handleChange(val, index);
                  }
                }}
                onKeyDown={(e) => {
                  if (
                    !/^[0-9]$/.test(e.key) &&
                    e.key !== "Backspace" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight" &&
                    !(e.ctrlKey && e.key === "v")
                  ) {
                    e.preventDefault();
                  }
                  handleKeyDown(e, index);
                }}
                inputMode="numeric"
                pattern="[0-9]*"
                ref={(el) => (inputRefs.current[index] = el)}
                className="w-12 text-center text-xl border-0 outline-none focus:shadow-none focus:ring-0"
              />
              {!value && (
                <span className="absolute inset-x-0 bottom-1/2 h-[2px] bg-[#484554] w-[6px] mx-auto" />
              )}
            </div>
          );
        })}
      </div>
      <p id="errors" className="font-semibold text-[#ED033B]"></p>
      <div className="mt-6 w-full">
        Didn’t receive code?{" "}
        <button
          id="resetOTPResendSaveData"
          onClick={() => {
            handleCallSendOTP();
            document.getElementById("resetOTPError").style.display = "none";
          }}
          className="text-berry hover:text-darkberry font-medium"
        >
          <u>Re-send</u>
        </button>
      </div>

      {!props.parentDetail.isValidAustralianAreaCode && (
        <button
          className="my-6 text-left text-berry hover:text-darkberry font-medium"
          onClick={handleTryAnotherMethod}
        >
          <u>Try another authentication method</u>
        </button>
      )}

      <p className="font-medium">
        By creating an account you accept our{" "}
        <a href="/home/termsandconditions" target="_blank">
          <u className="text-berry">Terms & Conditions</u>
        </a>
      </p>
    </div>
  );
};

export default VerifyOTP;
